<!--
NFC > directions > room to screen
@author bmk11u
-->
<template>
  <div>
    <Nav name="Room"/>
    <h4>Rooms in {{ buildingName }}</h4>
    <SearchList name="room" id="roomId" label="roomName" :data="'/map/buildings/' + buildingId + '/rooms'"
      :href="'directions?geoLatitude=' + x + '&geoLongitude=' + y + '&toId={roomId}&toType=R'" @dataLoaded="onDataLoaded">
      <router-link :to="defaultUrl"
        class="list-group-item list-group-item-action list-group-item-primary">
        No thanks, just the building
      </router-link>
    </SearchList>
    <div id="pusher"></div>
    <Footer active="notifications" v-if="authenticated"/>
  </div>
</template>

<script>
import SearchList from '@/components/SearchList.vue'
import LocationsCommon from '@/mixins/LocationsCommon.js'
import Footer from '@/components/FooterMenu.vue'

export default {
  name: 'RoomTo',
  components: {
    SearchList,
    Footer
  },
  mixins: [
    LocationsCommon
  ],
  data () {
    let x = this.$route.query.x
    let y = this.$route.query.y
    let buildingId = this.$route.query.buildingId
    let buildingName = this.$route.query.buildingName
    let defaultUrl = 'directions?geoLatitude=' + x + '&geoLongitude=' + y + '&toId=' + buildingId + '&toType=B'
    return {
      authenticated: this.$cookies.get('authenticated'),
      x: x,
      y: y,
      buildingId: buildingId,
      buildingName: buildingName,
      defaultUrl: defaultUrl
    }
  },
  methods: {
    onDataLoaded (numberOfItems) {
      if (numberOfItems === 0) {
        this.$router.push(this.defaultUrl + '&auto=true')
      }
    }
  }
}
</script>
